const styles = () => ({
  root: {
    margin: '-8px auto',
    border: 0,
    boxShadow: 'none',
    width: '1200px',
  },
  table: {
    width: '1000px',
    margin: '0 auto',
    border: '1px solid #eee',
  },
});

export default styles;
